import axios from 'axios';
import {addressValidationAPI} from "../config/constants";

export const validateAddress = async (address, locality) => {
  try {
    const response = await axios
      .post(addressValidationAPI, {
        address: {
          regionCode: "US",
          locality,
          addressLines: [address]
        }
      });

    const {data: { result }} = response;
    if (result.address) {
      if (result.address.unconfirmedComponentTypes) {
        return result.address.unconfirmedComponentTypes
      } else return [];
    }
    else return [];
  } catch (e) {
    console.error('Error validating Address: ', e);
  }
};